/**
 * @desc 出口报关报表导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.customsDeclarationMaster.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
